import React from 'react';
import { Toast } from 'antd-mobile';
import { useTranslation, copyText } from '../../index';
import { Modal } from '../modal';
import './index.less';

const link = window.location.href;

export const BrowserMask = () => {
  const { t } = useTranslation();
  const handleCopyLink = () => {
    copyText(link, () => {
      Toast.show(String(t('copy_succees')));
    });
  };

  return (
    <div className="browser-mask" dt-eid="default_browser_guid_dialogue">
      <div className="title">{t('webview_text')}</div>
      <div className="desc">{t('open_webview_text')}</div>
      <div className="split">
        <div className="line"></div>
        <div className="or">{t('or')}</div>
        <div className="line"></div>
      </div>
      <div className="desc">{t('open_webview_link')}</div>
      <div
        className="clip"
        id="clip-link-text"
        data-clipboard-text={link}
        onClick={handleCopyLink}
        dt-eid="default_browser_copylink"
      >
        <div className="clip-link" id="clip-link">
          {link}
        </div>
        <div className="clip-text">{t('copy_link')}</div>
      </div>
    </div>
  );
};

export const openBrowserMask = () => {
  Modal.show({
    content: <BrowserMask />,
    actions: [
      {
        text: 'ok',
        key: 'ok',
        closeOnAction: true,
      },
    ],
    closeIcon: false,
  });
};
